import { SplitContentBlockData } from 'api/cms';
import { AmpSplitContentBlock } from 'cms/blocks/Amp/AmpSplitContentBlock';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { SplitContentBlock } from './SplitContentBlock';

export const SplitContentBlockMapping: BlockMapping<SplitContentBlockData> = {
  invariant: [],
  width: 'GRID',
  Component: SplitContentBlock,
  AmpComponent: AmpSplitContentBlock,
};
